export const CUSTOMERS_LIST_LOAD_SUCCESS = 'CUSTOMERS_LIST_LOAD_SUCCESS';
export const CUSTOMERS_LIST_LOAD_ERROR = 'CUSTOMERS_LIST_LOAD_ERROR';
export const CUSTOMERS_SET_SORT = 'CUSTOMERS_SET_SORT';
export const CUSTOMERS_SET_CUSTOMER = 'CUSTOMERS_SET_CUSTOMER';
export const CUSTOMERS_CLEAR_CUSTOMER_DATA = 'CUSTOMERS_CLEAR_CUSTOMER_DATA';
